import React from 'react';
import { Link } from 'react-router-dom';

type TagLabelsProps = {
    labels?: string[] | undefined;
    preserveOrder?: boolean | undefined;
    urlPathname?: string | undefined;
};

export function TagLabels(props: TagLabelsProps) {
    if (!props.labels) {
        return null;
    }
    let { labels } = props;
    if (!Array.isArray(labels) || labels.length === 0) {
        return null;
    }
    labels = props.preserveOrder ? props.labels : props.labels.sort();

    return (
        <div className="clearfix">
            {props.labels &&
                props.labels.map((label, i) => (
                    <React.Fragment key={i}>
                        {props.urlPathname ? (
                            <Link to={labelLink(props.urlPathname, label)} className="tag-label fs10 fw600">
                                {label}
                            </Link>
                        ) : (
                            <span className="tag-label fs10 fw600">{label}</span>
                        )}
                    </React.Fragment>
                ))}
        </div>
    );
}

function labelLink(pathname: string, label: string): string {
    const searchParams = new URLSearchParams({ labels: label });
    return `${pathname}?${searchParams.toString()}`;
}
